import React from 'react';

import {EXPORT_AUDIT_LOG_DISPLAY_STRING} from 'audit/AuditConstants';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';

import * as AuditActions from './AuditActions';

interface ExportAuditLogButtonProps {
  buttonStyle: ButtonStyle;
  className?: string;
  ids: Array<string>;
  buttonSize?: ButtonSize;
  customHandleClick?: () => void;
}

class ExportAuditLogButton extends React.Component<ExportAuditLogButtonProps> {
  static defaultProps = {
    buttonStyle: ButtonStyle.TERTIARY_BLUE,
    buttonSize: ButtonSize.SMALL,
    ids: [],
  };

  private handleClick = (): void => {
    const {customHandleClick, ids} = this.props;
    if (customHandleClick) {
      customHandleClick();
    } else {
      AuditActions.exportAuditLogs(ids);
    }
  };

  render(): JSX.Element {
    return (
      <Tooltip placement={FloatingPlacement.TOP} text={EXPORT_AUDIT_LOG_DISPLAY_STRING}>
        <Button
          buttonStyle={this.props.buttonStyle}
          className={this.props.className}
          disabled={!this.props.customHandleClick && this.props.ids.length === 0}
          icon="audit-trail"
          onClick={this.handleClick}
          size={this.props.buttonSize}
        />
      </Tooltip>
    );
  }
}

export default ExportAuditLogButton;
